export enum SettingsCirclesDataEventObjectsEnum {
  CIRCLE_ADD = 'teammate_group.add',
  CIRCLE_CREATE = 'teammate_group.create',
  CIRCLE_EDIT = 'teammate_group.edit',
}
